import { render, staticRenderFns } from "./CheckboxGroupField.vue?vue&type=template&id=3dbdbfe2"
import script from "./CheckboxGroupField.vue?vue&type=script&lang=js"
export * from "./CheckboxGroupField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports